import Shahed from './main/shahed.png'
import Developer from './main/developer.jpg'

const Images = {
    Shahed,
    Developer
}

export default Images